import React, { useCallback, useEffect } from 'react';
import { TextInput } from '~/features/dashboard/components/add-deal/components/text-input';
import css from '~/features/dashboard/components/quick-song-entry/styles.module.scss';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { getUserProfileData } from '~/features/dashboard/store/selectors';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';
import { updateDefaultThunk } from '~/features/dashboard/store/actions.thunks';
import { UserProfile } from '~/models/profile/UserProfile.dto';

interface DefaultsProps {
    setOpen: (event: boolean) => void;
}

export const DefaultsTab: React.FC<DefaultsProps> = ({ setOpen }) => {
    const userProfileResponse = useSelector(getUserProfileData);
    const dispatch = useThunkDispatch();

    const { register, handleSubmit, setValue } = useForm<UserProfile>({
        defaultValues: {},
    });

    const onSubmit1 = useCallback(
        (data: UserProfile) => {
            dispatch(updateDefaultThunk({ ...data })).then(() => {
                setOpen(false);
            });
        },
        [dispatch] // eslint-disable-line
    );

    useEffect(() => {
        setValue('defaultWriterName', userProfileResponse?.defaultWriterName);
        setValue('defaultPublisherName', userProfileResponse?.defaultPublisherName);
        setValue('defaultArtistName', userProfileResponse?.defaultArtistName);
    }, [userProfileResponse]); // eslint-disable-line

    return (
        <div style={{ width: '30vw' }} className="">
            <form onSubmit={handleSubmit(onSubmit1)} className={css.form}>
                <TextInput
                    className={css.textInput}
                    label={'Writer Name'}
                    name={'defaultWriterName'}
                    register={register}
                    defaultValue={userProfileResponse?.defaultWriterName}
                />
                <TextInput
                    className={css.textInput}
                    label={'Publisher Name'}
                    name={`defaultPublisherName`}
                    register={register}
                    defaultValue={userProfileResponse?.defaultPublisherName}
                />
                <TextInput
                    className={css.textInput}
                    label={'Artist Name'}
                    name={'defaultArtistName'}
                    register={register}
                    defaultValue={userProfileResponse?.defaultArtistName}
                />
                <button className={css.btnBlue} type={'submit'}>
                    Apply
                </button>
            </form>
        </div>
    );
};
